export enum UserAgent {
  MobileAppIOS = 'YouHelpMobileAppIOS',
  MobileAppAndroid = 'YouHelpMobileAppAndroid',
}
